<div class="dots">
    <img src="/assets/images/speaker-on.svg" (click)="showVolumeSlider($event);$event.stopPropagation()"  />
    <input *ngIf="volumeSlider" type="range" min="0" max="1" step="0.1" value="{{chatVolume}}"
        (change)="changeVolume($event)" (click)="$event.stopPropagation()">
    <!-- <i class="fa fa-ellipsis-h"></i> -->
</div>
